import React from 'react';

const SearchForm = ({onSubmit, onSearchOnKeyUp, placeholder = "Rechercher...", ...rest}) => {
	// Séparer les props du formulaire des autres props
	const { 'aria-label': ariaLabel, 'data-testid': dataTestId, ...inputProps } = rest;
	
	return (
		<form 
			id="search-form" 
			className="search-form" 
			onSubmit={onSubmit} 
			aria-label={ariaLabel || "Formulaire de recherche"}
			data-testid={dataTestId}
		>
			<div className="search-form-group" role="group" aria-labelledby="search-form-label">
				<label id="search-form-label" htmlFor="search-form-text" className="visually-hidden">
					{placeholder}
				</label>
				<input 
					id="search-form-text" 
					className="search-form-text" 
					onKeyUp={onSearchOnKeyUp} 
					placeholder={placeholder}
					aria-describedby="search-form-description"
					{...inputProps} 
				/>
				<div id="search-form-description" className="visually-hidden">
					Appuyez sur Entrée pour lancer la recherche ou cliquez sur le bouton Rechercher
				</div>
				<span className="search-form-submit">
					<button 
						id="search-form-submit-input" 
						className="search-form-submit-input" 
						type="submit"
						aria-label="Lancer la recherche"
					>
						Rechercher
					</button>
				</span>
			</div>
		</form>
	);
};

export default SearchForm;
